import {connect} from 'react-redux'

import type {State} from '../../../../reducers/types'
import {getBuild} from '../../../../selectors'

import BuildStatsBar from './BuildStatsBar'
import type {OwnProps, StateProps} from './BuildStatsBar.types'

export default connect(
  (state: State, {id}: OwnProps): StateProps => ({
    popupLoading: getBuild(state, id) == null,
  }),
  {},
)(BuildStatsBar)
